'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ItemCount;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _constantsList = require('@bibliocommons/constants-list');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ItemCount(_ref) {
  var count = _ref.count;

  return _react2.default.createElement(
    'div',
    { className: 'cp-item-count' },
    _react2.default.createElement(_reactIntl.FormattedMessage, {
      id: 'user_list_item_count',
      values: {
        count: count || '0',
        max_items: _constantsList.MAX_LIST_ITEMS
      } })
  );
}

ItemCount.propTypes = {
  count: _react.PropTypes.number
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/item-count/components/ItemCount.component.js
// module id = 1299
// module chunks = 0